export const priorityData = ['low', 'medium', 'high'];

export const tagsData = ['home', 'work', 'health', 'team', 'chores'];

